import { useIsMobile } from "@app/lib/swr/useIsMobile";
import { Chip, MessageChatCircle, Tooltip } from "@dust-tt/sparkle";

const badgeLabel = "Third-party assistant present";

export function ThirdPartyAssistantBadge() {
  const isMobile = useIsMobile();
  return (
    <div className="flex h-9 shrink-0 items-center">
      <Tooltip
        label="An outside assistant such as Instinct takes part in this chat. It sees only what its owner's chief of staff sends it."
        tooltipTriggerAsChild
        trigger={
          <span className="inline-flex h-9 items-center">
            <Chip
              className={isMobile ? "shrink-0 [&>span]:sr-only" : "shrink-0"}
              color="info"
              icon={MessageChatCircle}
              label={badgeLabel}
              size="mini"
            />
          </span>
        }
      />
    </div>
  );
}
